// extracted by mini-css-extract-plugin
export default {"deactivateAction":"UserFormLayout_deactivateAction__964xw","formExtraActions":"UserFormLayout_formExtraActions__1c7mC","modalContent":"UserFormLayout_modalContent__z3s8I"};